import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { fetchUserDetails, login, removeCheckoutClientInfo, switchUserRole } from "../../services/authService";
import ReCAPTCHA from "react-google-recaptcha";
import "./Login.css";
import Alert from "../HtmlElements/Alert";
import { useUser } from "../../context/UserContext";
import { getUrlDetailsObj, getUserStatsObject, logCampaignStats, recordActivity } from "../../services/commonService";
import { JS_CSS_IMG_VERSION, PROJECT_DISPLAY_NAME } from "../../config/apiConfig";

const Login = () => {
  const location = useLocation();
  const [successMessage, setSuccessMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [recap, setRecap] = useState("");
  const [showRecaptcha, setshowRecaptcha] = useState("");
  const timerId = useRef(null);
  const captchadisplaycount = 3;

  const { user, setUser, setUserRole, handleLogout } = useUser();
  const [showPassword, setShowPassword] = useState(false);
  var pageParsedData = getUrlDetailsObj(useLocation, useParams);

  var currentUrl = useLocation().pathname;

  const toggleShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const checkCaptchaRender = () => {
    var loginFailedCount = parseInt(localStorage.getItem("loginFailedCount"));
    if (loginFailedCount >= captchadisplaycount) {
      setshowRecaptcha(1);
    }
  };

  useEffect(() => {
    const successMessage = sessionStorage.getItem("successMessage");
    if (successMessage) {
      setSuccessMessage(successMessage);
      sessionStorage.removeItem("successMessage"); // Clear the message
    }

    checkCaptchaRender();
  }, [showRecaptcha]);

  useEffect(() => {
    if (error) {
      //Creating a timeout
      timerId.current = setTimeout(() => {
        setError(false);
      }, 5000);
    }

    return () => {
      //Clearing a timeout
      clearTimeout(timerId.current);
    };
  }, [error]);

  const postCampaignStats = async (obj) => {

    if(!obj?.source){
      return 
    }

    try {
      const response = await logCampaignStats(obj);
      // console.log("Logged stats successfully:", response);
    } catch (error) {
      // Handle silently or log to a service
      console.error("Failed to log campaign stats", error);
      // Optional: show a non-intrusive message in UI
    }
  };

  const getCurrentUrlQueryParams = () => {
    const params = new URLSearchParams(location.search);
    const statsObj = {};
    for (const [key, value] of params.entries()) {
      statsObj[key] = value;
    }
    return statsObj;
  }

  useEffect(() => {
    const statsObj = getCurrentUrlQueryParams()
    statsObj.is_logged_in = 0
    postCampaignStats(statsObj);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (recap || !showRecaptcha) {
      if (!email || !password) {
        setError("Please enter both email and password.");
        return;
      }

      setLoading(true);

      const userStat = getUserStatsObject("Login", "login", "Login successful", currentUrl);
      userStat.url_details = pageParsedData;

      try {
        const isLogin = await login(email, password, userStat);
        if (isLogin === true) {
          const statsObj = getCurrentUrlQueryParams()
          statsObj.is_logged_in = 1;
          await postCampaignStats(statsObj);
          
          // const userStat = {
          //   type: "Login",
          //   action: "login",
          //   data: "Login successful",
          //   page: currentUrl
          // };
          
          // recordActivity(userStat);
          // navigate('/users');
          localStorage.setItem("loginFailedCount", 0);
          let userInfo = await fetchUserDetails();
          let current_role_key = userInfo?.role_key;
          /*
          if(current_role_key === 'CLIENT'  && (userInfo?.is_onboarded == null || userInfo?.is_onboarded === 0)){
            // window.location.replace("/accounts");
            window.location.replace('/user_profile/profile');
          }else{
            window.location.replace("/users");
          }
          */
         
          removeCheckoutClientInfo();

          var default_user_page = "/users"

          if(current_role_key === 'SALES_DEMO' || current_role_key === 'ANALYST'){
            // navigate('/clients_accounts');
            // window.location.replace('/sales_accounts');
            default_user_page = "/sales_accounts"
          }else if(current_role_key === 'CLIENT' || current_role_key === 'CLIENT_EMPLOYEE'){
            userInfo.is_onboarded = 1;
            if(userInfo?.is_onboarded == null || userInfo?.is_onboarded === 0){
              // navigate('/user_profile/profile');
              
              // window.location.replace('/user_profile/profile');
              default_user_page = "/user_profile/profile"
              
            }else{
              // navigate('/dashboard');
              
              // window.location.replace('/clients_accounts');
              default_user_page = "/clients_accounts"
            }
          }else{
            // window.location.replace("/users");
            default_user_page = "/users"
          }

          const redirectPath = sessionStorage.getItem('redirectAfterLogin');
          sessionStorage.removeItem('redirectAfterLogin');

          window.location.replace(redirectPath || default_user_page);

        } else {
          // const userStat = {
          //   type: "Login Attempt",
          //   action: "Login_failed",
          //   data: "Login failed",
          //   page: currentUrl
          // };
          // const userStat = getUserStatsObject("Login Attempt", "Login_failed", "Login failed", currentUrl);
          // recordActivity(userStat);
          setError("Incorrect username or password. Please try again.");
          var loginFailedCount = parseInt(
            localStorage.getItem("loginFailedCount")
          );
          var loginFailed = parseInt(loginFailedCount) + 1;
          localStorage.setItem("loginFailedCount", loginFailed);

          checkCaptchaRender();
        }
      } catch (err) {
        setError(err.message || "Login Failed");
      } finally {
        setLoading(false);
      }
    } else {
      setError("Please complete the CAPTCHA to proceed.");
    }
  };

  return (
    <div>
      <div className="main-container">
        <div className="main-content">
        <div className="login_page_wrapper">
          <div className="sub_wrapper">
            <div className="row">
                <div className="col-md-7 pr-0 same_height_block pl-0">
                <div className="login_left_block">
                      <div className="login_new">
                        <div className="row logo">
                            <div className="cell">
                              <div className="login_account_logo custom_row">
                                  <div className="cell">
                                    <img src={`/img/mnm_logo_inner.png?version=${JS_CSS_IMG_VERSION}`} alt="logo" width="140" className="logo_login" />
                                  </div>
                              </div>
                            </div>
                        </div>
                        <div className="row middle_content">
                            <div className="cell">
                              <div className="login_content custom_row">
                                  {/* <h5 className="login_subhead">Unleash the Power of Client Insights: Drive Sales with {PROJECT_DISPLAY_NAME}</h5> */}
                                  <h5 className="login_subhead">Unlock the Power of Client Insights and Supercharge Your Sales with {PROJECT_DISPLAY_NAME}!</h5>
                                  <p className="login_para">Get a 360° view of your clients, uncover untapped opportunities, and create unstoppable sales pipelines—all with our ultimate sales intelligence platform.</p>
                                  {/* <p className="login_para">Gain a comprehensive view of your clients, identify new opportunities, and build winning sales pipelines with our all-in-one sales intelligence platform.</p> */}
                                  {/* <button
                                    type="btn"
                                    className="btn custom_login_btn">
                                  Lets get started
                                  </button> */}
                                  <div className="login_list">
                                    <div className="login_li">
                                      <img src="/img/3x.png" className="img_icon"/>
                                      <p className="login_li_span">Faster Account Research:</p>  
                                      <p className="login_li_para">Optimize your sales preparation with AI-powered insights, saving you valuable weekly hours on client analysis.</p>
                                    </div>
                                    <div className="login_li">
                                      <img src="/img/rates.png" className="img_icon"/>
                                      <p className="login_li_span">Boost Pipeline Growth by 40%:</p>  
                                      <p className="login_li_para">Discover new buying centers and unlock opportunities that drive your sales targets.</p>
                                    </div>
                                    <div className="login_li">
                                      <img src="/img/boost.png" className="img_icon"/>
                                      <p className="login_li_span">Increase Win Rates by 25%:</p>  
                                      <p className="login_li_para">Leverage tailored talk tracks and actionable strategies to close deals confidently.</p>
                                    </div>
                                  </div>
                              </div>
                            </div>
                        </div>
                        <div className="row base">
                            <div className="cell">
                              <div className="login_bottom_mail custom_row">
                                  <div className="cell">
                                    <div className="d-flexn">
                                      <div className="email_block_left">
                                        <a target="_blank" href="https://www.marketsandmarkets.com" className="link_mail"><i className="fa fa-globe mr-2" aria-hidden="true"></i> <span className='url_email'> www.marketsandmarkets.com </span> </a>
                                      </div>
                                      <div className="email_block">
                                        <a href="mailto:salesplay@marketsandmarkets.com" className="link_mail"><i className="fa fa-envelope-open mr-2" aria-hidden="true"></i> <span className='url_email'> salesplay@marketsandmarkets.com</span> </a>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                            </div>
                        </div>
                      </div>
                  </div>
                </div>
                <div className="col-md-5 pl-0 same_height_right">
                  <div className="login_right_block ">
                    <div className="login_block">
                      <div className="login_top_icon vis_hidden">
                      <img src="/img/login/flag.png" alt="logo" width="50" className="login_icon" />
                    </div>
                    <h5 className="login_head">Login</h5>
                    <p className="login_para">Please enter your email and password</p>
                    <div className="main_form_login">
                    {successMessage && (
                    <Alert type="success" message={successMessage} />
                  )}
                  {error && <Alert type="danger" message={error} />}
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label custom_label">
                        Email 
                      </label>
                      <span className="block input-icon input-icon-right">
                        <input
                          type="email"
                          className="form-control custom_form_control"
                          id="email"
                          placeholder="Please enter your Email Address"
                          autoComplete="off"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </span>
                    </div>

                    <div className="mb-3">
                      <label
                        htmlFor="password"
                        className="form-label custom_label"
                      >
                        Password
                      </label>
                      <span className="block input-icon input-icon-right">
                        <input
                          type={showPassword ? 'text' : 'password'}
                          className="form-control custom_form_control"
                          id="password"
                          placeholder="Please enter your Password"
                          autoComplete="off"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        /><div className="input-group-append" style={{'position': 'absolute', 'right': '10px', 'top': '7px', 'zIndex': '5'}}>
                        <span className="" onClick={toggleShowPassword} style={{ cursor: 'pointer' }}>
                          <i className={`fa fa-eye${ showPassword ? '' : '-slash' }`} aria-hidden="true"></i>
                        </span>
                    </div>
                      </span>
                      
                    </div>

                    {showRecaptcha === 1 && (
                      <div className="mb-3">
                        <ReCAPTCHA
                          sitekey="6LdrhAwqAAAAAGG8IdTF7Y1cYyH3tA4aMkzWli0f"
                          onChange={(val) => setRecap(val)}
                        />
                      </div>
                    )}


                    <div className="space-6"></div>
                    <button
                      disabled={loading}
                      type="submit"
                      className="btn btn-primary custom_log_btn w-100"
                    >
                      {loading ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : (
                        <i className="fa fa-keyj"></i>
                      )}{" "}
                      Login
                    </button>


                    <div className="forgot_block">
                    <span className='forgot_span'> <a href="/forgotpassword" className="forgot_password">
                        Forgot Password ?
                      </a></span>
                    </div>
                  </form>
                    </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
          {/* <div className="login-container">
                <div className="center">
                  <h4 className="blue" id="id-company-text">
                    <img src="/img/mnm_logo_inner.png" width="200" alt="Logo" />
                  </h4>
                </div>
                <div className="space-4"></div>

                <h2 className="login_head header blue">
                  <i className="ace-icon fa fa-sign-in blue mr-2"></i>Please
                  Enter Your Information
                </h2>
                <div className="space-6"></div>
                {successMessage && (
                  <Alert type="success" message={successMessage} />
                )}
                {error && <Alert type="danger" message={error} />}
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label custom_label">
                      Email Address
                    </label>
                    <span className="block input-icon input-icon-right">
                      <input
                        type="email"
                        className="form-control custom_form_control"
                        id="email"
                        placeholder="Please enter your Email Address"
                        autoComplete="off"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <i className="ace-icon fa fa-user"></i>
                    </span>
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="password"
                      className="form-label custom_label"
                    >
                      Password
                    </label>
                    <span className="block input-icon input-icon-right">
                      <input
                        type="password"
                        className="form-control custom_form_control"
                        id="password"
                        placeholder="Please enter your Password"
                        autoComplete="off"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <i className="ace-icon fa fa-lock"></i>
                    </span>
                  </div>

                  {showRecaptcha === 1 && (
                    <div className="mb-3">
                      <ReCAPTCHA
                        sitekey="6LdrhAwqAAAAAGG8IdTF7Y1cYyH3tA4aMkzWli0f"
                        onChange={(val) => setRecap(val)}
                      />
                    </div>
                  )}

                  <div className="">
                    <a href="/forgotpassword" className="forgot_password">
                      Forgot Password ?
                    </a>
                  </div>

                  <div className="space-6"></div>
                  <button
                    disabled={loading}
                    type="submit"
                    className="btn btn-primary custom_login_btn width-35 pull-right"
                  >
                    {loading ? (
                      <i className="fa fa-spinner fa-spin"></i>
                    ) : (
                      <i className="fa fa-key"></i>
                    )}{" "}
                    Login
                  </button>
                  

                </form>
              </div>  */}
        </div>
      </div>
    </div>
  );
};

export default Login;
